var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean, IsNotEmpty, IsNotIn, IsOptional, IsString, Matches } from 'class-validator';
export class UpdateOfficeLocationDeviceDto {
    name;
    description;
    deviceType;
    serialNumber;
    manufacturer;
    model;
    isActive;
}
__decorate([
    Expose(),
    IsNotIn([null], { message: 'name must not be null' }),
    IsString(),
    IsNotEmpty(),
    Matches(/\S/, { message: 'name must contain at least one non-whitespace character' }),
    IsOptional(),
    __metadata("design:type", String)
], UpdateOfficeLocationDeviceDto.prototype, "name", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateOfficeLocationDeviceDto.prototype, "description", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateOfficeLocationDeviceDto.prototype, "deviceType", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateOfficeLocationDeviceDto.prototype, "serialNumber", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateOfficeLocationDeviceDto.prototype, "manufacturer", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateOfficeLocationDeviceDto.prototype, "model", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateOfficeLocationDeviceDto.prototype, "isActive", void 0);
//# sourceMappingURL=update-office-location-device.dto.js.map